export function useSiteBranding() {
  const config = useRuntimeConfig()

  const defaultSiteName = 'GVGmall'
  const defaultLogoPath = '/logo.png'

  const rawName = String((config.public as any)?.siteName || '').trim()
  const siteName = rawName && rawName !== 'Site' ? rawName : defaultSiteName

  const rawLogo = String(config.public.logoPath || '').trim()
  
  // Detectar se é GVGmall e usar logo local (10 years trusted)
  const isGvgmall = siteName === 'GVGmall' || siteName === 'gvgmall'
  const gvgmallLogo = '/logo-gvgmall-10yrs.webp'
  
  const logoPath = rawLogo && rawLogo !== '/logo.png' ? rawLogo : (isGvgmall ? gvgmallLogo : defaultLogoPath)
  const supportEmail = String(config.public.supportEmail || '').trim() || ''
  const topbarText = String(config.public.topbarText || '').trim() || ''
  const topbarLink = String(config.public.topbarLink || '').trim() || ''
  const whatsappNumber = String(config.public.whatsappNumber || '').trim() || ''

  const companyLegalName = String((config.public as any).companyLegalName || '').trim() || ''
  const companyCnpj = String((config.public as any).companyCnpj || '').trim() || ''
  const companyAddress = String((config.public as any).companyAddress || '').trim() || ''
  const companyPhone = String((config.public as any).companyPhone || '').trim() || ''
  const companyEmail = String((config.public as any).companyEmail || '').trim() || ''
  const googleReviewsUrl = String((config.public as any).googleReviewsUrl || '').trim() || ''
  const googleReviewRequestUrl = String((config.public as any).googleReviewRequestUrl || '').trim() || ''

  return {
    siteName,
    logoPath,
    supportEmail,
    topbarText,
    topbarLink,
    whatsappNumber,
    companyLegalName,
    companyCnpj,
    companyAddress,
    companyPhone,
    companyEmail,
    googleReviewsUrl,
    googleReviewRequestUrl
  }
}

export function useSiteUrl() {
  const config = useRuntimeConfig()
  const configured = String(config.public.siteUrl || '').trim()

  if (import.meta.server) {
    try {
      const url = useRequestURL()
      const origin = String(url?.origin || '').trim()
      if (origin) return origin.replace(/\/$/, '')
    } catch {
      // ignore
    }
  }

  if (configured) return configured.replace(/\/$/, '')

  if (typeof window !== 'undefined' && window.location?.origin) {
    return String(window.location.origin).replace(/\/$/, '')
  }

  return ''
}
